const createSkeletonWidth = (idx: number, { min = 100, max = 220, steps = 7, offset = 2 } = {}) =>
  `${Math.min(Math.floor((max - min) / steps) * ((idx + offset) % steps), max - min) + min}px`;

export default createSkeletonWidth;
